import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faNetworkWired, 
  faMapMarkedAlt, 
  faTasks, 
  faComments, 
  faUserFriends, 
  faEnvelope, 
  faUser, 
  faProjectDiagram, 
  faCog, 
  faSignOutAlt, 
  faUserCircle,
  faListAlt
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import { User } from '../../services/userService';

const Navbar: React.FC = () => {
  const { isAuthenticated, user, logout, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isHomePage = location.pathname === '/';

  return (
    <BootstrapNavbar bg="white" expand="lg" className="py-3 shadow-sm">
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <FontAwesomeIcon icon={faNetworkWired} className="text-primary me-2" />
          <span className="fw-bold">DataNest</span>
        </BootstrapNavbar.Brand>

        <BootstrapNavbar.Toggle aria-controls="navbarNav" />

        <BootstrapNavbar.Collapse id="navbarNav">
          <Nav className="ms-auto align-items-center">
            {isHomePage && (
              <>
                <Nav.Link href="#features" className="fw-bold">Features</Nav.Link>
                <Nav.Link href="#how-it-works" className="fw-bold">How It Works</Nav.Link>
              </>
            )}
            {isAuthenticated && (
              <Nav.Link as={Link as any} to="/map" className="fw-bold">
                <FontAwesomeIcon icon={faMapMarkedAlt} className="me-1" /> Map
              </Nav.Link>
            )}
            {isAuthenticated && (
              <Nav.Link as={Link as any} to="/messages" className="fw-bold">
                <FontAwesomeIcon icon={faComments} className="me-1" /> Messages
              </Nav.Link>
            )}
            {isAuthenticated && (
              <Nav.Link as={Link as any} to="/tasks" className="fw-bold">
                <FontAwesomeIcon icon={faTasks} className="me-1" /> Tasks
              </Nav.Link>
            )}
            {isAuthenticated && (
              <Nav.Link as={Link as any} to="/forum" className="fw-bold">
                <FontAwesomeIcon icon={faListAlt} className="me-1" /> Forum
              </Nav.Link>
            )}
            {isAuthenticated && (
              <Nav.Link as={Link as any} to="/connections" className="fw-bold">
                <FontAwesomeIcon icon={faUserFriends} className="me-1" /> Connections
              </Nav.Link>
            )}
            {isLoading ? (
              <span className="navbar-text">Loading...</span>
            ) : isAuthenticated && user ? (
              <NavDropdown 
                title={
                  <>
                    {user.profile_image_url && (
                      <img 
                        src={user.profile_image_url}
                        alt="Profile" 
                        width="30" 
                        height="30" 
                        className="rounded-circle me-2" 
                      />
                    )}
                    {user.name}
                  </>
                }
                id="basic-nav-dropdown" 
                align="end"
                show={showDropdown}
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <NavDropdown.Item as={Link as any} to={`/profile/${user.id}`}> 
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" /> My Profile
                </NavDropdown.Item>
                <NavDropdown.Item as={Link as any} to="/tasks?view=my-tasks">
                  <FontAwesomeIcon icon={faTasks} className="me-2" /> My Tasks
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <>
                <Nav.Link as={Link as any} to="/login" className="fw-bold me-2">Login</Nav.Link>
                <Button as={Link as any} to="/register" variant="primary" size="sm" className="rounded-pill px-3">Sign Up</Button>
              </>
            )}
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
